import { EditorState, RangeSetBuilder } from '@codemirror/state';
import { Decoration, DecorationSet, EditorView, ViewPlugin, ViewUpdate } from '@codemirror/view';

/**
 * Create a CodeMirror plugin to add decorations for CSV delimiters.
 */
export const csvHighlightPlugin = ViewPlugin.fromClass(
  class {
    decorations: DecorationSet;

    constructor(view: EditorView) {
      this.decorations = this.buildDecorations(view.state);
    }

    update(update: ViewUpdate) {
      if (update.docChanged || update.viewportChanged) {
        this.decorations = this.buildDecorations(update.state);
      }
    }

    buildDecorations(state: EditorState) {
      const builder = new RangeSetBuilder<Decoration>();

      for (let pos = 0, cursor = state.doc.iterRange(0, state.doc.length); !cursor.next().done;) {
        if (cursor.value === ',') {
          builder.add(pos, pos + 1, Decoration.mark({ class: 'csv-delimiter' }));
        }
        pos++;
      }

      return builder.finish();
    }

    destroy() {}
  },
  {
    decorations: (v) => v.decorations
  }
);

/**
 * CSS to highlight the `csv-delimiter` class.
 */
export const csvStyles = EditorView.baseTheme({
  '.csv-delimiter': {
    backgroundColor: 'rgba(255, 165, 0, 0.3)' // Highlight color
  }
});
